<template>
  <div class="designer-panel">
    <header>
      <h1>{{ title }}</h1>
      <h2
        v-if="subtitle"
        v-html="subtitle"
      />
    </header>
    <main ref="scrollPanel">
      <component
        :is="componentType"
        :item.sync="item"
        :branch-types="branchTypes"
      />
    </main>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
import DesignerQuestionPanel from './_shared/designer-question-panel'
import DesignerSectionPanel from './_shared/designer-section-panel'

export default {
  name: 'DesignerPanel',
  props: {
    branchTypes: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    item: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  computed: {
    title () {
      const titles = {
        section: 'Editar Sección',
        subsection: 'Editar Subsección',
        question: 'Editar Pregunta'
      }
      return titles[this.item.$group] || 'PANEL DE EDICIÓN'
    },
    subtitle () {
      if (this.item.$group === 'question') {
        const subtitles = {
          multiple_option: 'Opción Múltiple',
          unique_option: 'Opción Única',
          range_option: 'Rango de Valores',
          true_or_false: 'Verdadero o Falso'
        }
        return subtitles[this.item.type]
      }

      return false
    },
    componentType () {
      const componentTypes = {
        section: DesignerSectionPanel,
        subsection: DesignerSectionPanel,
        question: DesignerQuestionPanel
      }
      return componentTypes[this.item.$group]
    }
  },
  watch: {
    item () {
      this.$refs.scrollPanel.scrollTop = 0
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.designer-panel {
  border-left: 1px solid #dddddd;
  height: 100vh;
  header {
    background-color: #fff;
    height: 80px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #dddddd;
    justify-content: center;
    h1 {
      @include font-primary(16px, bold);
      color: #444;
      text-transform: uppercase;
      padding-left: 20px;
      margin: 0;
    }
    h2 {
      @include font-primary(14px, regular);
      color: #444;
      padding-left: 20px;
      margin: 0;
    }
  }
  main {
    height: calc(100vh - 80px);
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/designer/designer-panel.vue